import { translateMessage } from "@/i18n/runtime";
import type { JournalEntryKind } from "@/types";

const journalKindLabelIds = {
  note: "common.journalKind.note",
  quote: "common.journalKind.quote",
  highlight: "common.journalKind.highlight",
  reflection: "common.journalKind.reflection",
} as const;

export function journalKindLabel(kind: JournalEntryKind): string {
  return translateMessage(journalKindLabelIds[kind]);
}

export function localizedReadingNote(note: string): string {
  return note === "Evening reading"
    ? translateMessage("common.demo.eveningReading")
    : note;
}
